import { Head, Link as InertiaLink, useForm } from "@inertiajs/react";
import { SubmitEvent } from "react";
import { Box, Button, Flex } from "@radix-ui/themes";
import { CalendarRange } from "lucide-react";
import { EditableSeason, ManagedTrack, SeasonFormData } from "@/types/shared";
import SeasonForm from "./_form";

interface Props {
  season: EditableSeason;
  tracks: ManagedTrack[];
  errors?: string[];
}

export default function EditSeason({ season, tracks, errors }: Props) {
  const { data, setData, patch, processing } = useForm<SeasonFormData>({
    season: {
      track_id: season.track_id,
      name: season.name,
      slug: season.slug,
      start_date: season.start_date,
      end_date: season.end_date,
      title_sponsor: season.title_sponsor,
      accent_color: season.accent_color,
      rules_url: season.rules_url,
      status: season.status,
      description: season.description,
      poster: null,
      remove_poster: false,
    },
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    patch(`/track_manager/seasons/${season.slug}`);
  };

  return (
    <div className="flex">
      <Head title="Edit Season" />
      <Box className="grow">
        <Box className="max-w-3xl mx-auto px-5 py-5">
          <Flex justify="end" mb="3">
            <Button asChild variant="soft" size="2">
              <InertiaLink
                href={`/track_manager/seasons/${season.slug}/events`}
              >
                <CalendarRange size={14} />
                Manage Events
              </InertiaLink>
            </Button>
          </Flex>
          <SeasonForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            tracks={tracks}
            title="Edit Season"
            submitLabel="Save Changes"
            hasPoster={season.has_poster}
            posterUrl={season.poster_url}
            isEdit
          />
        </Box>
      </Box>
    </div>
  );
}
